import { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, Spin, Alert, Typography } from 'antd';
import {
  BookOutlined,
  SwapOutlined,
  WarningOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import api from '@/lib/api';
import type { DashboardStats } from '@/lib/types';

const { Title } = Typography;

/** 默认统计数据 */
const defaultStats: DashboardStats = {
  totalBooks: 0,
  borrowedCount: 0,
  overdueCount: 0,
  todayTransactions: 0,
};

export default function DashboardPage() {
  const [stats, setStats] = useState<DashboardStats>(defaultStats);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await api.get<DashboardStats>('/dashboard/stats');
        setStats(data);
      } catch (err: unknown) {
        const msg =
          (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
          '加载仪表盘数据失败';
        setError(msg);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  return (
    <div>
      <Title level={3} style={{ marginBottom: '24px' }}>
        仪表盘概览
      </Title>

      {error && (
        <Alert
          type="warning"
          message={error}
          description="请确认后端服务是否正常运行"
          showIcon
          style={{ marginBottom: '24px' }}
        />
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card className="dashboard-stat-card">
            <Statistic
              title="藏书总数"
              value={stats.totalBooks}
              prefix={<BookOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="dashboard-stat-card">
            <Statistic
              title="在借数"
              value={stats.borrowedCount}
              prefix={<SwapOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="dashboard-stat-card">
            <Statistic
              title="逾期数"
              value={stats.overdueCount}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="dashboard-stat-card">
            <Statistic
              title="今日借还数"
              value={stats.todayTransactions}
              prefix={<CalendarOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
